import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

export default function FaqCta() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* FAQ 摘录 */}
        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <div className="flex items-end justify-between">
            <h2 className="font-heading text-2xl font-black text-foreground-950">你可能想问</h2>
            <Link
              to="/faq"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              全部问答
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
          <ul className="mt-6 space-y-3">
            {faqs.slice(0, 4).map((f) => (
              <li key={f.q}>
                <Link
                  to="/faq"
                  className="flex items-center gap-3 rounded-lg bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-200"
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                    <i className="ri-question-mark text-xs" aria-hidden="true"></i>
                  </span>
                  <span className="flex-1">{f.q}</span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-300" aria-hidden="true"></i>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className="relative flex flex-col justify-center overflow-hidden rounded-lg bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 p-8 text-background-50 md:p-10">
          <i className="ri-road-map-line pointer-events-none absolute -right-6 -top-6 text-[9rem] text-background-50/10" aria-hidden="true"></i>
          <p className="inline-flex w-fit items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium backdrop-blur">
            <i className="ri-lightbulb-flash-line text-sm" aria-hidden="true"></i>
            别急着站队，先看地图
          </p>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug md:text-3xl">
            与其被热搜牵着走，
            <br />
            不如把一件事一次看明白
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/85">
            从一份完整的事件地图开始，时间线、人物、观点与溯源都排好队等着你。看懂之后，你也能成为那个「理性旁观」的人。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to="/events"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-accent-50"
            >
              开始围观热榜
              <i className="ri-fire-fill" aria-hidden="true"></i>
            </Link>
            <Link
              to="/methodology"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              先学吃瓜方法论
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}